// Shared month-key ("YYYY-MM") parser for the new CBRE/general-engine
// registries. Mirrors the parsing already done privately inside
// src/utils/cortevaInvoiceRegistry.js's cortevaMonthKey() (left untouched
// there to avoid touching already-proven production code) — accepts either
// an ISO date ("2026-02-15"), a short month label ("Feb-2027"), or a plain
// YYYY-MM string.
const MONTHS = { jan: "01", feb: "02", mar: "03", apr: "04", may: "05", jun: "06", jul: "07", aug: "08", sep: "09", oct: "10", nov: "11", dec: "12" };

export function parseMonthKey(value) {
  const text = String(value || "").trim();
  if (!text) return "";
  let match = text.match(/(20\d{2})[- /](1[0-2]|0?[1-9])(?!\d)/);
  if (match) return `${match[1]}-${String(match[2]).padStart(2, "0")}`;
  match = text.match(/(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*[- /]*(\d{2,4})/i);
  if (match) {
    const year = match[2].length === 2 ? `20${match[2]}` : match[2];
    return `${year}-${MONTHS[match[1].slice(0, 3).toLowerCase()]}`;
  }
  return "";
}
